import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { WorkScheduleFormDto } from '@zaoblako/shared/modules/security/dtos/work-schedule/work-schedule-form.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { WorkScheduleFormInterface } from '@zaoblako/shared/modules/security/dtos/work-schedule/work-schedule-form.dto';

import * as yup from 'yup';

/** Work schedule response body */
export interface WorkScheduleFindInterface extends WorkScheduleFormInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Schedule creation date and time */
  created: Date;
  /** Schedule last update date and time */
  updated: Date;
  /** Schedule soft deletion date and time */
  deleted: Date;
  /** Schedule creator */
  createdBy?: UserFindInterface;
  /** Users who work on this schedule */
  users?: UserFindInterface[];
}

/** Work schedule response body - DTO schema */
export const WorkScheduleFindDto = SerdeDtoClass.from<WorkScheduleFormInterface, WorkScheduleFindInterface>(
  WorkScheduleFormDto,
  SecurityDtoKeysEnum.WORK_SCHEDULE_FIND_DTO,
  {
    id: {
      label: 'Номер',
      serializer: yup.number(),
    },
    created: {
      label: 'Дата создания',
      serializer: yup.date(),
    },
    updated: {
      label: 'Дата последнего изменения',
      serializer: yup.date(),
    },
    deleted: {
      label: 'Дата удаления',
      serializer: yup.date(),
    },
    createdBy: {
      optional: true,
      label: 'Автор',
      nested: SecurityDtoKeysEnum.USER_FIND_DTO,
      serializer: (_, nested) => nested,
    },
    users: {
      optional: true,
      label: 'Автор',
      nested: SecurityDtoKeysEnum.USER_FIND_DTO,
      serializer: (_, nested) => yup.array(nested),
    },
  },
);
